<template>
  <MainHeader />
  <MainSidebar />
  <div class="main-content bg_gray d-flex flex-column transition overflow-hidden">
    <BreadcrumbMenu pageTitle="income_category" />

    <div class="card border-0 shadow-none rounded-1 mb-25">
      <div class="card-body p-xl-40">
        <div class="row g-3 align-items-center">
          <div class="col-lg-8">
            <div class="search-box position-relative">
              <input type="text" v-model="searchQuery" :placeholder="$t('income_category_page.search_placeholder')" class="form-control bg-white h-55 shadow-none pe-5" />
              <span class="search-icon"><i class="ri-search-line"></i></span>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="d-flex justify-content-lg-end">
              <button type="button" class="btn style-one d-inline-flex align-items-center h-55 px-4" data-bs-toggle="modal" data-bs-target="#incomeCategoryModal" @click="openCreateModal">
                <i class="ri-add-circle-line me-1"></i>
                {{ $t("income_category_page.create_category") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <IncomeCategory :categories="categories" :loading="loading" @edit-category="openEditModal" @delete-category="deleteCategory" />

    <div class="flex-grow-1"></div>
    <MainFooter />
  </div>

  <CreateIncomeCategoryModal
    :form="form"
    :loading="saving"
    :is-edit-mode="isEditMode"
    @update-field="updateField"
    @generate-code="generateCode"
    @submit="submitCategory"
  />
</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";

import BreadcrumbMenu from "../../components/Common/BreadcrumbMenu.vue";
import MainFooter from "../../components/Layouts/MainFooter.vue";
import MainHeader from "../../components/Layouts/MainHeader.vue";
import MainSidebar from "../../components/Layouts/MainSidebar.vue";
import IncomeCategory from "../../components/Income/IncomeCategory/IncomeCategory.vue";
import CreateIncomeCategoryModal from "../../components/Income/IncomeCategory/CreateCategoryModal.vue";
import { useIncomeCategory } from "../../composables/useIncomeCategory";

export default defineComponent({
  name: "IncomeCategoryPage",
  components: { MainHeader, MainSidebar, BreadcrumbMenu, IncomeCategory, CreateIncomeCategoryModal, MainFooter },
  setup() {
    const state = useIncomeCategory();
    onMounted(state.fetchCategories);
    return state;
  },
});
</script>

<style scoped>
.search-box { width: min(100%, 380px); }
.search-box .form-control { padding-left: 18px; border: 1px solid #e6ebf2; border-radius: 8px; background: #fff; color: #1f2940; box-shadow: 0 8px 20px rgba(15, 23, 42, 0.04); }
.search-box .form-control:focus { border-color: #5d5fef; box-shadow: 0 0 0 3px rgba(93, 95, 239, 0.12); }
.search-icon { position: absolute; right: 16px; top: 50%; transform: translateY(-50%); color: #8f9bb3; pointer-events: none; font-size: 18px; }
</style>
